import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'termsAndConditionsLink',
  initialState: null as string | null,
  reducers: {
    setTermsAndConditionsLink(state, action: PayloadAction<string | null>) {
      return action.payload || null;
    },
  },
});

export const { setTermsAndConditionsLink } = slice.actions;
export default slice.reducer;
